import { useEffect, useState } from 'react';
import { MOUTH_SHAPES } from '../constants/effects';
import { pickMouthHoldMs, pickNextMouthShape } from '../utils/mouthUtils';

/**
 * While talking, keeps switching Fizzy's mouth between closed, oval and teeth
 * at uneven speeds so it looks like real speech. At rest it's a closed smile.
 */
export default function useTalkingMouth(isTalking) {
  const [mouthShape, setMouthShape] = useState(MOUTH_SHAPES.CLOSED);

  useEffect(() => {
    if (!isTalking) {
      setMouthShape(MOUTH_SHAPES.CLOSED);
      return undefined;
    }
    let currentShape = MOUTH_SHAPES.CLOSED;
    let timer = null;
    const showNextShape = () => {
      currentShape = pickNextMouthShape(currentShape);
      setMouthShape(currentShape);
      timer = setTimeout(showNextShape, pickMouthHoldMs(currentShape));
    };
    showNextShape();
    return () => clearTimeout(timer);
  }, [isTalking]);

  return mouthShape;
}
